module.exports = __webpack_public_path__ + "static/media/az-5.14721e94.jpg";